/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsDesign,
    MelcoModelsDesignFromJSON,
    MelcoModelsDesignFromJSONTyped,
    MelcoModelsDesignToJSON,
    MelcoModelsDesignCollectionDefaultDesign,
    MelcoModelsDesignCollectionDefaultDesignFromJSON,
    MelcoModelsDesignCollectionDefaultDesignFromJSONTyped,
    MelcoModelsDesignCollectionDefaultDesignToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsDesignCollectionFullItem
 */
export interface MelcoModelsDesignCollectionFullItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    design_count?: number;
    /**
     * 
     * @type {MelcoModelsDesignCollectionDefaultDesign}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    default_design?: MelcoModelsDesignCollectionDefaultDesign;
    /**
     * 
     * @type {Array<MelcoModelsDesign>}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    design_list?: Array<MelcoModelsDesign> | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsDesignCollectionFullItem
     */
    updated_date?: Date | null;
}

export function MelcoModelsDesignCollectionFullItemFromJSON(json: any): MelcoModelsDesignCollectionFullItem {
    return MelcoModelsDesignCollectionFullItemFromJSONTyped(json, false);
}

export function MelcoModelsDesignCollectionFullItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDesignCollectionFullItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'design_count': !exists(json, 'design_count') ? undefined : json['design_count'],
        'default_design': !exists(json, 'default_design') ? undefined : MelcoModelsDesignCollectionDefaultDesignFromJSON(json['default_design']),
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(MelcoModelsDesignFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function MelcoModelsDesignCollectionFullItemToJSON(value?: MelcoModelsDesignCollectionFullItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'design_count': value.design_count,
        'default_design': MelcoModelsDesignCollectionDefaultDesignToJSON(value.default_design),
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(MelcoModelsDesignToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


